import { render, staticRenderFns } from "./ActivityQuestionChoices.vue?vue&type=template&id=3e84620b&scoped=true&"
import script from "./ActivityQuestionChoices.vue?vue&type=script&lang=js&"
export * from "./ActivityQuestionChoices.vue?vue&type=script&lang=js&"
import style0 from "./ActivityQuestionChoices.vue?vue&type=style&index=0&id=3e84620b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e84620b",
  null
  
)

export default component.exports